// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2IDXk","range":"MonthRangeSwitch_range__2dX8x","disabled":"MonthRangeSwitch_disabled__qi4JE"};